
import { Component, Vue } from 'vue-property-decorator';

@Component
export default class StatisticLoader extends Vue {}
